import { render, staticRenderFns } from "./addStorage.vue?vue&type=template&id=de29faf4&scoped=true&"
import script from "./addStorage.vue?vue&type=script&lang=js&"
export * from "./addStorage.vue?vue&type=script&lang=js&"
import style0 from "./addStorage.vue?vue&type=style&index=0&id=de29faf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de29faf4",
  null
  
)

export default component.exports